import React from 'react';
import { Link } from 'react-router-dom';
import { Row, Col, Space, Typography, Image, Grid } from 'antd';
import iconCheck from '../../../../assets/img/logo/check.svg';

const { Text } = Typography;
const { useBreakpoint } = Grid;

function GetBreakPoint() {
  const screens = useBreakpoint()
  return screens;
}

export default function modal(props) {
  const { getJobDetail } = props
  const { sm } = GetBreakPoint()

  return (
    <React.Fragment>
      {
        sm ?
        <Row>
          <Col span={10}>
            <Image
              width={200}
              src={iconCheck}
              preview={false}
            />
          </Col>
          <Col span={14}>
            <Space className="mt-64" direction="vertical">
              <Space direction="vertical">
                <Text className="fs-20 primary-color" strong>Success!</Text>
                <Text className="fs-1 dark-color">{`Your application was sent to ${getJobDetail.data.companyName}`}</Text>
              </Space>
              <Text className="fs-13 dark-color">You can view your applications anytime in your
                <Link className="ml-4 fs-13 info-color" to="/candidate/applications/applied">
                  application page
                </Link>
              </Text>
            </Space>
          </Col>
        </Row>
        :
          <Row>
            <Col span={9}>
              <Image
                width={130}
                src={iconCheck}
                preview={false}
              />
            </Col>
            <Col span={14}>
              <Space className="mt-64" direction="vertical">
                <Space direction="vertical">
                  <Text className="fs-20 primary-color" strong>Success!</Text>
                  <Text className="fs-1 dark-color">{`Your application was sent to ${getJobDetail.data.companyName}`}</Text>
                </Space>
                <Text className="fs-13 dark-color">You can view your applications anytime in your
                  <Link className="ml-4 fs-13 info-color" to="/candidate/applications/applied">
                    application page
                  </Link>
                </Text>
              </Space>
            </Col>
            <Col span={1}></Col>
          </Row>
      }
    </React.Fragment>
  )
}